module.exports = __webpack_public_path__ + "img/user-icon.245e50fd.png";